export const createButtonPlay = (video) => {
  return `
    <div class="button-play-container">
        <button class="button-play" >
            <i class="fas fa-play fa-2x"></i>
        </button>
    </div>
    `;
};
